import * as React from 'react';
import { useControlled } from '../../../../internal/hooks';
export function useControlledValue(props, defaultValue) {
  const {
    onChange
  } = props;
  const [value, setValue] = useControlled({
    controlled: props.value,
    default: defaultValue
  });
  const handleChange = React.useCallback(value => {
    setValue(value);
    if (onChange) {
      onChange(value);
    }
  }, [onChange, setValue]);
  return {
    value,
    onChange: handleChange
  };
}